<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <load-mode-create-or-update v-model="loadMode" :errors="errors"></load-mode-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="load-mode"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import LoadModeCreateOrUpdate from './components/LoadModeCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        LoadModeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            loadMode:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Yükleme Modu",key:"Name", thClass:"w-100",sortable:true,},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.loadMode.Id = 0
            this.loadMode.Name = null
           
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.loadMode.Id = item.Id
            this.loadMode.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.LoadMode.CreateOrUpdate(this.editing,this.loadMode)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.LoadMode.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} yükleme modunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.LoadMode.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>